import axios from "axios";

const axiosSvClient = axios.create({
  baseURL: `https://api.staarvani.com/app/v1`,
});

axiosSvClient.interceptors.request.use((config) => {
  const token = JSON.parse(sessionStorage.getItem('auth'));

  if (token) {
    config.headers.Authorization = `Bearer ${(token && token?.accessToken) ?? "" }`;
  }
  return config;
}, (error) => Promise.reject(error));

axiosSvClient.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 403) {
    window.location.href = '/';
    sessionStorage.removeItem("auth")
  }
  return Promise.reject(error);
});

export default axiosSvClient;